// перенесли эхти стили в header.php а то в адаптиве их нет
// require("../../templates/.default/style/common.css");
// require("../../templates/.default/bower_components/jquery-ui/themes/smoothness/jquery-ui.min.css");
// require("../../templates/.default/style/animate.css");
// require("../../templates/.default/style/slick.css");
// require("../../templates/.default/ion.calendar/css/ion.calendar.css");
// require("../../templates/.default/selectize/css/selectize.css");
// require("../../templates/.default/src/style/rating-widget.css");
require("../../templates/.default/src/style/style.css");

// if (window.location.href.indexOf('?dev=Y') != -1) {
//     require("../../templates/.default/css/mobile.css");
// }

import _ from "lodash";
import Cookies from "js-cookie";
import Vue from "vue";
import VueCompositionAPI from '@vue/composition-api'
import Vuex from "vuex";
import is from "is_js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Vuelidate from "vuelidate";

import { ObserveVisibility } from 'vue-observe-visibility';
Vue.directive('observe-visibility', ObserveVisibility)

Vue.use(Vuex);
window._ = _;
window.Cookies = Cookies;
window.Vue = Vue;
window.is = is;
window.jsPDF = jsPDF;
window.html2canvas = html2canvas;

Vue.use(Vuelidate);
Vue.use(VueCompositionAPI);

import store from "./store";
window.vxCommonStore = store;

window.dataLayer = window.dataLayer || [];

Vue.filter("pluralize_ru", function($n) {
    var forms = vmApp.$refs.calc.toArray(arguments, 1);
    var plural_form = $n % 10 == 1 && $n % 100 != 11 ? forms[0] : ($n % 10 >= 2 && $n % 10 <= 4 && ($n % 100 < 10 || $n % 100 >= 20) ? forms[1] : forms[2]);
    return $n + " " + plural_form;
});

Vue.filter("plural", function(n, forms) {
    return n % 10 == 1 && n % 100 != 11 ? forms[0] : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? forms[1] : forms[2]);
});

Vue.filter("format_number", function(val, separator) {
    if (val !== undefined) {
        return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + separator);
    }
});
if (typeof $ === "undefined") {
    $ = {};
}
if ((Cookies.get("DISABLE_META_VIEWPORT") && Cookies.get("DISABLE_META_VIEWPORT") == 1) || (Cookies.get("userDevice") && Cookies.get("userDevice") == "desktop")) {
    $("meta[name=\"viewport\"]").remove();
    $("body").removeClass("mobile");
    $("link[href='/local/templates/.default/style/style_mobile.css']").remove();
}

window.getPluralize = function(number, one, two, five) {
    number = Math.abs(number);
    number %= 100;
    if (number >= 5 && number <= 20) {
        return five;
    }
    number %= 10;
    if (number == 1) {
        return one;
    }
    if (number >= 2 && number <= 4) {
        return two;
    }
    return five;
};

// Добавляем "contains"-селектор не чувствительный к регистру
if (typeof jQuery === "undefined") {
    jQuery = {};
}
jQuery.expr[":"].icontains = jQuery.expr.createPseudo(function(arg) {
    return function(elem) {
        return jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
});


$(function() {

    initSelecize();

    $(".seo-text-btn").click(function() {
        let $this = $(this),
            $parent = $this.closest(".seo-text");

        $(".seo-text__text--full").slideToggle(300);

        $parent.toggleClass("js__opened");
    });

    $(document).on("click", ".item_bl_question_head", function() {
        var $win_width = $(window).width();
        var $that = $(this);
        $that.toggleClass("active");
        $that.next().slideToggle();
    });

    $("form.check_multiple_send").each(function(key, val) {
        $(this).on("submit", function(e) {
            var $form = $(this);
            if ($($form).hasClass("form--processed")) {
                e.preventDefault();
                return false;
            }
            $($form).addClass("form--processed");
            setTimeout(function(e) {
                $($form).removeClass("form--processed");
            }, 10000);
        });
    });

    if ($("body").hasClass("mobile")) {
        $(document).on("click, .btn_show_hide_filter", function() {
            if (!$("#catalog-filter-form").is(":visible")) {
                Cookies.set("mobile_catalog_filter_visible", 1);
                $("#catalog-filter-form").slideDown();
            } else {
                Cookies.set("mobile_catalog_filter_visible", 0);
                $("#catalog-filter-form").slideUp();
            }
        });
        if (Cookies.get("mobile_catalog_filter_visible") == 1) {
            $("#catalog-filter-form").slideDown();
        }
    }

    $(document).on("click", ".order_list__item__header", function(e) {
        $(this).closest(".order_list__item").toggleClass("expanded");
    });

    $(".datepicker").each(function() {
        $(this).ionDatePicker({
            onSelect(date, input) {
                var selectedDate = moment(date, "DD.MM.YYYY");
                var curDate = moment();
                if ((selectedDate.diff(curDate, "days") <= -1)) {
                    $(input).val("");
                }
            }
        });
        $(this).change(function() {
            var selectedDate = moment($(this).val(), "DD.MM.YYYY");
            var curDate = moment();
            if ((selectedDate.diff(curDate, "days") <= -1)) {
                $(this).val("");
            } else {
                $(this).val(selectedDate.format("DD.MM.YYYY"));
            }
        });
    });

    $(document).on("click", ".fb-close", function(e) {
        e.preventDefault();
        $.fancybox.close();
    });


    $(document).on("click", ".disabled_btn", function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $(".left_catalog .product_section").first().addClass("product_section--first");
    $(".left_catalog .product_section").last().addClass("product_section--last");

    $("input[name=\"REGISTER[PASSWORD]\"]").on("blur", function(e) {
        if ($(this).val().length < 6) {
            $("<p class=\"password_note\">Пароль должен быть не меньше 6 символов</p>").insertAfter(this);
            window.setTimeout(
                function() {
                    $(".password_note").remove();
                },
                4000
            );
        } else {
            $(".password_note").remove();
        }
    });


});

window.setPhoneMask = function(el) {
    $(el).each(function() {
        if ($(this).val().length) {
            var phone = $(this).val().match(/\d+/ig).join("");
            if (phone.length >= 11) {
                phone = phone.substr(1, (phone.length - 1));
                $(this).val(phone);
            }
        }
        $(this).inputmask({
            mask: !is.android() ? "+7 (999) 999-99-99" : "+79999999999"
        });
    });
};

window.setCodeMask = function(el) {
    $(el).each(function() {
        $(this).inputmask({
            mask: "9999"
        });
    });
};

window.setDateMask = function(el) {
    $(".mask-date").inputmask("99.99.9999");
};


window.ProductStoresInit = function() {
    var self = this;

    this.init = function() {
        window.$(document).on("click", ".product_stores_link", function(e) {
            let params = window.$(this).data();
            let data = {};
            for (let key in params) {
                let value = params[key] + "";
                if (value.indexOf(",") > -1) {
                    value = value.split(",");
                }
                data[key] = value;
            }
            self.popupShow(data);
        });
    };

    this.popupShow = function(data) {
        data["ajax_command"] = "get_product_stores";
        data["z"] = "1";
        $.fancybox({
            type: "ajax",
            href: "/local/php_interface/ajax/",
            ajax: {
                data: data,
                type: "post"
            },
            helpers: {
                title: {
                    type: "inside"
                }
            },
            beforeShow() {
                $("body").addClass("fancybox-active");
            },
            afterShow() {
                if ($("body").hasClass("mobile")) {
                    window.scrollTo(0, 0);
                }
            },
            afterClose() {
                $("body").removeClass("fancybox-active");
            }
        });
    };

    this.init();
};
window.ProductStores = new ProductStoresInit();

window.initSelecize = function(elem) {
    $(elem).selectize({
        plugins: ["remove_button"],
        onDropdownOpen: function(elem) {
            var selected_val = $(this.$control).find('.item').attr('data-value');
            this.default_val = selected_val;
            this.clear(true);
        },
        onDropdownClose: function(elem) {
            if (!this.getValue() && typeof(this.default_val) != 'undefined') {
                this.setValue(this.default_val);
            }
            $(this.$control).trigger('change');
        },
    });
    // if (!$("body").hasClass("desktop")) {
    //     return;
    // }
    // console.log(111);
    // $('select.selectize:not(.selectized)').selectize({
    //   onDropdownOpen(elem) {
    //     var selected_val = $(this.$control).find('.item').attr('data-value');
    //     this.default_val = selected_val;
    //     this.clear(true);
    //   },
    //   onDropdownClose(elem) {
    //     if (!this.getValue() && typeof(this.default_val) != 'undefined') {
    //       this.setValue(this.default_val);
    //     }
    //   },
    // });
};

window.showHeaderMessage = function(message, status, delay) {
    hideHeaderMessage();
    window.hideHeaderMessageTimer = null;
    clearTimeout(window.hideHeaderMessageTimer);
    if (typeof(window.headerMessageTimer) != "undefined" && window.headerMessageTimer !== null) {
        return;
    }
    if (!message) {
        return;
    }
    if (!status) {
        status = "success";
    }
    var messageClass = "at_ok";
    if (status == "success") {
        messageClass = "at_ok";
    } else if (status == "error" || status == "at_error") {
        messageClass = "at_error";
    } else if (status == "yellow" || status == "at_yellow") {
        messageClass = "at_yellow";
    } else if (status == "gift" || status == "at_gift") {
        messageClass = "at_gift";
    }
    if (!delay) {
        delay = 5000;
    }
    setTimeout(
        function() {
            $(".top_line_at_wrap").addClass(messageClass);
        },
        200
    );
    $(".top_line_at_wrap .top_at_cont")
        .html(message);
    clearTimeout(window.headerMessageTimer);
    window.headerMessageTimer = setTimeout(
        function() {
            hideHeaderMessage();
        },
        delay
    );
};

window.hideHeaderMessage = function() {
    $(".top_line_at_wrap").removeClass("at_ok");
    $(".top_line_at_wrap").removeClass("at_error");
    $(".top_line_at_wrap").removeClass("at_yellow");
    $(".top_line_at_wrap").removeClass("at_gift");
    clearTimeout(window.headerMessageTimer);
    window.headerMessageTimer = null;
};

window.XPageInit = function() {
    var self = this;

    this.init = function() {

    };

    // фильтр в каталоге (чтобы стрелочка была рядом со словом)

	// $("select[name='sort_by']").change(sortBySelect);
	sortBySelect();

	function sortBySelect(){
		const $this = $("select[name='sort_by']");
		const $selectContainer = $this.closest(".cat_top_filter_item");
		let $fakeLabel = $selectContainer.find('.cat_top_filter_item_label');

		// console.log($selectContainer, $this);

		if (!$fakeLabel.length){
			$selectContainer.append('<div class="cat_top_filter_item_label"></div>');
			$fakeLabel = $selectContainer.find('.cat_top_filter_item_label');
		}

		$fakeLabel.text(`${$this.find('option[value='+$this.val()+']').text()}`);
	}

    this.ajax = function(settings) {
        var settings = settings || {};
        var defaultSettings = {};
        settings.url = "/local/php_interface/ajax/";
        settings.type = settings.type || "post";
        settings.dataType = settings.dataType || "json";
        var onSuccess = settings.success || null;
        settings.success = function(response) {
            if (typeof(response.message) != "undefined") {
                if (typeof(response.message.type) != "undefined") {
                    if (response.message.type == "header") {
                        showHeaderMessage(response.message.message, response.message.status, response.message.delay);
                    }
                }
            }
            if (typeof(onSuccess) == "function") {
                onSuccess(response);
            }
        };
        settings.data["z"] = "1";
        $.ajax(settings);
    };

    this.init();
};
window.XPage = new XPageInit();
document.addEventListener("readystatechange", () => {
    if (document.readyState !== "interactive") {
        return;
    }
    if (typeof window.BX === "undefined" || typeof window.BX.bitrix_sessid === "undefined") {
        console.warn("нет возможности зарегистрировать формы");
        return;
    }
    let fromInputs = Array.from(document.body.querySelectorAll("[name='sessid']"));
    fromInputs.forEach(input => {
        input.value = window.BX.bitrix_sessid();
    });
});
Vue.component("arend", {
    props: {
        regions: {
            type: Array,
            default: []
        }
    },
    data: () => ({
        regionName: "",
        visibleRegions: [],
        isShortList: true
    }),
    mounted: function() {
        this.visibleRegions = this.regions;
        $("#arend-region-search-form").submit(function(e) {
            e.preventDefault();
            return false;
        });
    },
    watch: {
        regionName: function(name, oldVal) {
            var visibleRegions;
            if (!name) {
                visibleRegions = this.regions;
            } else {
                visibleRegions = _.filter(this.regions, function(region) {
                    return _.startsWith(_.toLower(region.NAME), _.toLower(name));
                });
            }
            this.visibleRegions = visibleRegions;
        }
    }
});

window.getDistanceFromLatLonInKm = function(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
};

function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

Vue.component("city-select-popup", () =>
    import ("./components/CitySelectPopup.vue"));
Vue.component("shops-select-popup", () =>
    import ("./components/ShopsSelectPopup.vue"));
Vue.component("merch-form-popup", () =>
    import ("./components/MerchFormPopup.vue"));
Vue.component("shops-select", () =>
    import ("./components/ShopsSelect.vue"));
Vue.component("age-confirmation-popup", () =>
    import ("./components/AgeConfirmationPopup.vue"));
Vue.component("age-confirmation-rejected-popup", () =>
    import ("./components/AgeConfirmationRejectedPopup.vue"));
Vue.component("auth-form", () =>
    import ("./components/AuthForm.vue"));

Vue.component("auth-form-phone", () =>
    import ("./components/AuthFormPhone.vue"));
Vue.component("fargot-calltelnet-form-phone", () =>
    import ("./components/FargotCalltelnetFormPhone.vue"));
Vue.component("confirm-reg-call", () =>
    import ("./components/ConfirmRegCall.vue"));

Vue.component("product-detail-tabs", () =>
    import ("./components/ProductDetailTabs.vue"));
Vue.component("product-desc", () =>
    import ("./components/ProductDesc.vue"));
Vue.component("ya-share", () =>
    import ("./components/YaShare.vue"));
Vue.component("vote", () =>
    import ("./components/Vote.vue"));
Vue.component("dk-active-form", () =>
    import ("./components/DKActiveForm.vue"));
Vue.component("order-complete-popup", () =>
    import ("./components/OrderCompletePopup.vue"));
Vue.component("city-select", () =>
    import ("./components/CitySelect.vue"));
Vue.component("share-cart-email-form-popup", () =>
    import ("./components/ShareCartEmailFormPopup.vue"));
Vue.component("kberlockholmes", () =>
    import ("./components/kberlockholmes.vue"));
Vue.component("cakeisalie", () =>
    import ("./components/cakeisalie.vue"));
Vue.component("Slider", () =>
    import ("@vueform/slider/dist/slider.vue2.js"));

Vue.component('vacancy-filter', () =>
    import ("./components/Vacancy/VacancyFilter"));
Vue.component('vacancy-select', () =>
    import ("./components/Vacancy/VacancySelect"));
Vue.component('vacancy-sort', () =>
    import ("./components/Vacancy/VacancySort"));
Vue.component('vacancies-list', () =>
    import ("./components/Vacancy/VacanciesList"));
Vue.component('vacancies-map', () =>
    import ("./components/Vacancy/VacancyMap"));
Vue.component('vacancy', () =>
    import ("./components/Vacancy/Vacancy"));
Vue.component("job-hero-search", () =>
    import ("./components/job/JobHeroSearch.vue"));
Vue.component("job-hero-rotating-text", () =>
    import ("./components/job/JobHeroRotatingText.vue"));

Vue.component("for-producer-form", () =>
    import ("./components/ForProducer/ForProducerForm.vue"));

import CityConfirm from "./components/CityConfirm.vue";

Vue.component("city-confirm", CityConfirm);

import BasketMobile from "./components/BasketMobile.vue";

Vue.component("basketline-mobile", BasketMobile);

import ProductAvailability from "./components/ProductAvailability.vue";

Vue.component("product-availability", ProductAvailability);

import Product from "./components/Product.vue";

Vue.component("product", Product);

import ScrollupBtn from "./components/ScrollupBtn.vue";

Vue.component("scrollup-btn", ScrollupBtn);

import Basketline from "./components/Basketline.vue";

Vue.component("basketline", Basketline);

import Basket from "./components/Basket.vue";

Vue.component("basket", Basket);

import GiftmainFilter from "./components/GiftmainFilter.vue";

Vue.component("giftmain-filter", GiftmainFilter);

import Quantity from "./components/Quantity.vue";

Vue.component("quantity", Quantity);

import CartQuantity from "./components/CartQuantity.vue";

Vue.component("cart-quantity", CartQuantity);

import DiscountCheck from "./components/DiscountCheck.vue";

Vue.component("discount-check", DiscountCheck);

import Disclaimer from "./components/Disclaimer.vue";

Vue.component("disclaimer", Disclaimer);

import PhoneConfirm from "./components/PhoneConfirm.vue";

Vue.component("phone-confirm", PhoneConfirm);

import PhoneConfirmRegistr from "./components/PhoneConfirmRegistr.vue";

Vue.component("phone-confirm-registr", PhoneConfirmRegistr);

import Popup from "./components/Popup.vue";

Vue.component("popup", Popup);

import VacancyMap from "./components/VacancyMap";

Vue.component("vacancy-map", VacancyMap);

import BalanceForm from "./components/GiftCard/BalanceForm";

Vue.component("balance-form", BalanceForm);

import CardDataForm from "./components/GiftCard/CardDataForm";

Vue.component("card-data-form", CardDataForm);

import GiftCardReg from "./components/GiftCard/GiftCardReg";

Vue.component("gift-card-reg", GiftCardReg);

import GiftPopup from "./components/GiftCard/GiftPopup";

Vue.component("gift-popup", GiftPopup);

import ActivateForm from "./components/GiftCard/ActivateForm";

Vue.component("activate-form", ActivateForm);

import writeLetterTheme from "./components/writeLetterTheme";

Vue.component("write-letter-theme", writeLetterTheme);

import writeLetterThemeContacts from "./components/writeLetterThemeContacts";

Vue.component("write-letter-theme-contact", writeLetterThemeContacts);

import personalProfileEdit from "./components/PersonalProfileEdit";

Vue.component("personal-profile-edit", personalProfileEdit);

Vue.component("feedback-smi-form", () =>
    import ("./components/forms/FeedbackSmiForm.vue"));
Vue.component("feedback-video-form", () =>
    import ("./components/forms/FeedbackVideoForm.vue"));

Vue.component("reviews-list", () =>
    import ("./components/ReviewsList.vue"));

import reviewForm from "./components/reviewForm";
Vue.component("review-form", reviewForm);

import Rating from "./components/reviews/Rating";
Vue.component("rating", Rating);
import ReviewFormButton from "./components/reviews/ReviewFormButton";
Vue.component("review-form-button", ReviewFormButton);
import ReviewModals from "./components/reviews/ReviewModals";
Vue.component("review-modals", ReviewModals);

// FORMS
import FindBugForm from "./components/forms/FindBugForm";
Vue.component("find-bug-form", FindBugForm);
import RenterForm from "./components/forms/RenterForm";
Vue.component("renter-form", RenterForm);
import DiscountActivationForm from "./components/forms/DiscountActivationForm";
Vue.component("discount-activation-form", DiscountActivationForm);
import DiscountPhoneChangeForm from "./components/forms/DiscountPhoneChangeForm";
Vue.component("discount-phone-change-form", DiscountPhoneChangeForm);
import AddNewsReviewForm from "./components/forms/AddNewsReviewForm";
Vue.component("add-news-review-form", AddNewsReviewForm);
import CookieInfo from "./components/shared/CookieInfo";
Vue.component("cookie-info", CookieInfo);


//import newsList from "./components/NewsList.vue";
//Vue.component("news-list", newsList);
Vue.component('news-list', () =>
    import ("./components/NewsList.vue"));

import defaultForm from "./components/defaultForm";

Vue.component("default-form", defaultForm);

Vue.component("filter-item", {
    props: {
        items: {
            type: Array,
            default: () => []
        },
        itemId: {
            type: Number,
            default: null
        }
    },
    data: () => ({
        search: "",
        expanded: false,
        itemExpanded: false,
        checkboxesHeight: null,
        useSearch: false
    }),
    methods: {
        toggle() {
            this.expanded = !this.expanded;
        },
        toggleItem() {
            this.itemExpanded = !this.itemExpanded;
            vxCommonStore.commit("toggleCatalogFilterExpandedOptions", this.itemId);
        },
    },
    computed: {
        itemsList() {
            var items = this.items;
            if (this.search) {
                items = _.filter(items, (item) => {
                    return _.includes(_.toLower(item.VALUE), _.toLower(this.search));
                });
            }
            items = _.sortBy(items, ["CHECKED"]).reverse();

            return items;
        },
        expandedIds: () => vxCommonStore.state.catalogFilterExpandedOptions || []
    },
    mounted() {
        if (this.items.length > 7) {
            this.checkboxesHeight = 7 * 22;
            this.useSearch = true;
        } else {
            this.useSearch = false;
        }
        if(this.expandedIds.length > 0)
            {
                if( ~this.expandedIds.indexOf(this.itemId) )
                    {
                        this.itemExpanded=true;
                    }
            }else{
                if(+this.itemId == 100){
                    this.itemExpanded=true;
                }
        }
    }
});
// noinspection JSAnnotator
Vue.component("vacancy-item", {
    template: "#vacancy-item",
    props: {
        vacancy: {
            type: Object,
            default: function() {
                return {};
            }
        },
        active: {
            default: false
        }
    },
    data() {
        return {
            selectedDisplayMode: 0,
            mapId: `ymap_${moment().unix()}_${this.vacancy.INDEX}`,
            map: {},
            selectedFilter: {
                metro: "",
                cityArea: ""
            },
            blItemAccordCStyle: {
                display: "none"
            }
        };
    },
    mounted() {
        if (this.active || this.vacancy.ACTIVE) {
            this.blItemAccordCStyle.display = "block";
        }
    },
    methods: {
        getVacancyAddresses: function(vacancy) {
            if (!vacancy) {
                return;
            }

            var addresses = [];
            for (var i = 0; i < vacancy.ITEMS.length; i++) {
                var v = vacancy.ITEMS[i];
                for (var a = 0; a < v.ADDRESSES_DATA.length; a++) {
                    var address = v.ADDRESSES_DATA[a];
                    //console.log('address', address);
                    if (this.selectedFilter.metro && this.selectedFilter.metro !== address.metro) {
                        continue;
                    }
                    if (this.selectedFilter.cityArea && this.selectedFilter.cityArea !== address.cityArea) {
                        continue;
                    }
                    address.vacancy_item_id = i;
                    addresses.push(address);
                }
            }
            addresses = _.uniqBy(addresses, "address");
            if (addresses.length == 1 && !vacancy.showSalary) {
                this.$set(vacancy, "showSalary", true);
            }
            if (address && address.length === 1) {
                //console.log(address[ 0 ]);
                this.selectVacancy(address[0]);
            }
            return addresses;
        },
        selectVacancy: function(address) {
            this.$emit("select-vacancy", this.vacancy, address);
        },
        sendResume: function(vacancy) {
            $("#resume_popup_form [name=\"PROPERTY[200][0]\"]").val(vacancy.NAME);
            $("#resume_popup_form [name=\"PROPERTY[317][0]\"]").val(vacancy.selected.ID);
            $.fancybox({
                href: "#resume_popup_form_container",
                beforeShow: function() {
                    $("body").addClass("fancybox-active");
                },
                afterShow: function() {
                    if ($("body").hasClass("mobile")) {
                        window.scrollTo(0, 0);
                    }
                },
                afterClose: function() {
                    $("body").removeClass("fancybox-active");
                }
            });
        },
        printVacancy: function(vacancy, e) {
            $(".no-print").removeClass("no-print");
            $(".printable").removeClass("printable");
            $(e.currentTarget).addClass("printable");
            var vacancies = this.vacancies;
            for (var k in vacancies) {
                vacancies[k].printable = false;
                if (vacancies[k].NAME == vacancy.NAME) {
                    vacancies[k].printable = true;
                }
            }
            this.vacancies = vacancies;
            if ($(".printable").length) {
                var el = $(".printable");
                var i = 0;
                while (true) {
                    i++;
                    $(el).addClass("printable");
                    el = $(el).parent();
                    if ($(el).is("body")) {
                        $(el).addClass("printable");
                        break;
                    }
                }
                $("body *:not(.printable)").not(".bl_item_accord--vacancy.printable *").addClass("no-print");
                window.print();
            }
        },
        downloadVacancy(e) {

            e.target.disabled = true;

            let body = new FormData;
            body.append("ajax_command", "print_page");
            body.append("pageUrl", e.target.href);
            body.append("z", "1");


            fetch("/local/php_interface/ajax/", {
                    method: "POST",
                    body
                })
                .then(response => response.json())
                .then(json => {
                    if (!json.pdfUrl) {
                        console.error(json);
                        return;
                    }

                    let a = document.createElement("a");
                    a.href = json.pdfUrl;
                    a.download = "vacancy";
                    a.click();


                })
                .catch(console.error)
                .finally(() => {
                    e.target.disabled = false;
                });


        },
        initMap() {

            if (this.mapItems.length === 0) {
                return;
            }

            let geoObjects = [];

            $("#" + this.mapId).html("");

            let curUrl = document.getElementById(this.mapId).getAttribute("data-cur-url");
            //console.log(curUrl);

            this.$root.initMap(() => {
                ymaps.ready(() => {

                    //центр вычисляем на основе средних значений
                    let totalCoordinates = {
                        lat: 0,
                        lng: 0,
                        cnt: 0
                    };

                    for (let mapItem of this.mapItems) {
                        if (!mapItem || !mapItem.SHOP_DATA || !mapItem.SHOP_DATA.COORDINATES || !mapItem.SHOP_DATA.COORDINATES.LAT || !mapItem.SHOP_DATA.COORDINATES.LNG) {
                            continue;
                        }
                        totalCoordinates.lat += +mapItem.SHOP_DATA.COORDINATES.LAT;
                        totalCoordinates.lng += +mapItem.SHOP_DATA.COORDINATES.LNG;
                        totalCoordinates.cnt++;
                    }


                    let center = [
                        totalCoordinates.lat / totalCoordinates.cnt,
                        totalCoordinates.lng / totalCoordinates.cnt
                    ];


                    this.map = new ymaps.Map(this.mapId, {
                        center: center,
                        zoom: 11,
                        controls: ["fullscreenControl"]
                    });

                    for (let mapItem of this.mapItems) {

                        if (!mapItem || !mapItem.SHOP_DATA || !mapItem.SHOP_DATA.COORDINATES || !mapItem.SHOP_DATA.COORDINATES.LAT || !mapItem.SHOP_DATA.COORDINATES.LNG) {
                            continue;
                        }

                        let mapIcon = "/local/templates/.default/img/kb_pin.png";


                        mapItem.balloonContent = _.template(`
                            <div class="shop_balloon">
                                <div class="shop_balloon__title">
                                    <%- mapItem.SHOP_DATA.NAME %>
                                </div>
                                <div class="shop_balloon__rezhim">
                                	<% for (let vacancy of mapItem.ITEMS) { %>
                                	    <b><%- vacancy.NAME %></b>
                                	    <div>Заработная плата от <%- vacancy.SALARY_FROM %> <% if (vacancy.SALARY_TO) { %> до <%- vacancy.SALARY_TO %> <% } %> </div>
                                	    <% if (vacancy.WORKING_HOURS) { %>
											<div>Режим работы: <%- vacancy.WORKING_HOURS %></div>
										<% } %>
                                	    <div class="shop_balloon__check">
											<a href="<%- curUrl + '&FILTER[PROPERTY_SHOP_XML_IDS]=' + mapItem.SHOP_DATA.XML_ID 
											+ '&FILTER[VACANCY_ID]=' + vacancy.ID
											+ '&FILTER[SHOP_ADDRESS]=' + mapItem.SHOP_DATA.NAME %>" 
											target="_blank" class="btn btn_blue btn--shop_balloon_check">Выбрать&nbsp;вакансию</a>
										</div>
                                	<% } %>
                                </div>
                            </div>
                        `)({
                            mapItem,
                            curUrl
                        });

                        let shopCoordinates = [+mapItem.SHOP_DATA.COORDINATES.LAT, +mapItem.SHOP_DATA.COORDINATES.LNG];

                        let placemark = new ymaps.Placemark(
                            shopCoordinates, {
                                balloonContent: mapItem.balloonContent
                            }, {
                                iconLayout: "default#image",
                                iconImageHref: mapIcon,
                                iconImageSize: [28, 33]
                            }
                        );
                        placemark.map_icon = mapIcon;
                        placemark.map_icon_selected = "/local/templates/.default/img/kb_red_check_box_2.png";


                        geoObjects.push(placemark);
                    }


                    let clusterer = new ymaps.Clusterer({
                        preset: "islands#redClusterIcons",
                        hasBalloon: false,
                        gridSize: 80
                    });

                    clusterer.add(geoObjects);
                    this.map.geoObjects.add(clusterer);

                    this.map.setBounds(clusterer.getBounds(), {
                        checkZoomRange: true
                    });
                });
            });
        },
        canShowButton(vacancy, a) {
            return false;
            /*let showResumeSendBtn=vacancy.selected.SHOW_RESUME_SEND_BTN;
             let isAdministrator  =vacancy.NAME.toLowerCase() == 'администратор магазина';
             let shopVacancy      =~['сотрудник опп', 'продавец-кассир', 'продавец',].indexOf(vacancy.NAME.toLowerCase());
             let selectedCity     =a.city == vacancy.selectedAddress.city;
             let selectedAddress                =a.address == vacancy.selectedAddress.address;
             return ( showResumeSendBtn || isAdministrator)  && !shopVacancy  && vacancy.showSalary  && selectedCity && selectedAddress;*/
        }
    },
    computed: {
        selectedDisplayModeCode() {
            let array = this.displayModes[this.selectedDisplayMode];
            if (!array) {
                return "";
            }
            return array.type;
        },
        mapItems() {

            if (!this.vacancy.ITEMS || !Array.isArray(this.vacancy.ITEMS)) {
                return [];
            }


            let vacanciesByShops = {};
            this.vacancy.ITEMS.forEach(vacancyItem => {
                if (!vacancyItem.SHOPS_DATA || !Array.isArray(vacancyItem.SHOPS_DATA)) {
                    return;
                }
                vacancyItem.SHOPS_DATA.forEach(shopData => {
                    if (!vacanciesByShops[shopData.XML_ID]) {
                        vacanciesByShops[shopData.XML_ID] = {
                            SHOP_DATA: shopData,
                            ITEMS: []
                        };
                    }
                    vacanciesByShops[shopData.XML_ID].ITEMS.push({
                        NAME: vacancyItem.NAME,
                        SALARY_FROM: vacancyItem.SALARY_FROM,
                        SALARY_TO: vacancyItem.SALARY_TO,
                        WORKING_HOURS: vacancyItem.WORKING_HOURS,
                        ID: vacancyItem.ID
                    });
                });
            });

            return Object.values(vacanciesByShops);
        },
        displayModes() {
            let result = [{
                type: "list",
                text: "Адрес"
            }];
            if (this.mapItems.length > 0) {
                result.push({
                    type: "map",
                    text: "Карта"
                });
            }
            return result;
        },
        listFilter() {
            let filter = {
                metro: [],
                cityArea: []
            };

            try {
                this.vacancy.ITEMS.forEach(item => {
                    item.ADDRESSES_DATA.forEach(address => {
                        if (address.metro && !filter.metro.includes(address.metro)) {
                            filter.metro.push(address.metro);
                        }
                        if (address.cityArea && !filter.cityArea.includes(address.cityArea)) {
                            filter.cityArea.push(address.cityArea);
                        }
                    });
                });
            } catch (e) {
                console.log("ALLO");
                console.error(e);
            }


            return filter;
        }
    },
    watch: {
        selectedDisplayModeCode(value) {
            //если выбрали карту и она еще не инициализирована, то инициализируем
            if (value === "map" && Object.values(this.map).length === 0) {
                this.initMap();
            }
        }
    }
});

Vue.component("vacancy-list", {
    data: () => ({
        mode: "",
        vacancies: [],
        expandedDepartments: []
    }),
    props: {
        items: {
            type: Array,
            default: []
        }
    },
    created() {

        // при переборе for in в массиве откуда-то берётся ключ "find"

        for (var k = 0; k < this.items.length; k++) {

            this.items[k].selected = this.items[k].ITEMS[0];
            this.items[k].selectedAddress = _.first(this.getVacancyAddresses(this.items[k]));
        }
        this.vacancies = this.items;

        // var vacancies = this.items;
        // for (var k in vacancies) {
        //   vacancies[k].selected = vacancies[k].ITEMS[0];
        //   vacancies[k].selectedAddress = _.first(this.getVacancyAddresses(vacancies[k]));
        // }
        // this.vacancies = this.items;
    },
    watch: {
        vacanciesType(val, oldVal) {
            if (!this.mode) {
                this.mode = (val == "Офис" || val == "Распределительный центр") ? "departments" : "vacancies";
            }
        }
    },
    computed: {
        vacanciesType: () => vxCommonStore.state.vacanciesType,
        vacanciesByDepartments() {
            var vacGroups = _.groupBy(this.vacancies, function(v) {
                return v.department;
            });
            var vacanciesByDepartments = [];
            for (var department in vacGroups) {
                if (!department) {
                    continue;
                }
                vacanciesByDepartments.push({
                    department,
                    items: vacGroups[department],
                    active: false
                });
            }
            return vacanciesByDepartments;
        },
        vacanciesWithoutDepartments() {
            var vacancies = _.filter(this.vacancies, function(v) {
                return !v.department;
            });
            return vacancies;
        }
    },
    methods: {
        onClickDepartmentName(department) {
            if (!~this.expandedDepartments.indexOf(department)) {
                this.expandedDepartments.push(department);
            } else {
                this.expandedDepartments.splice(this.expandedDepartments.indexOf(department), 1);
            }
        },
        selectVacancy: function(vacancy, address) {
            var vacancies = this.vacancies;
            for (var k in vacancies) {
                if (vacancies[k].NAME == vacancy.NAME) {
                    vacancies[k].selected = vacancies[k].ITEMS[address.vacancy_item_id];
                    vacancies[k].selectedAddress = address;
                    vacancies[k].showSalary = true;
                }
            }
            this.vacancies = vacancies;
        },
        getVacancyAddresses: function(vacancy) {
            if (!vacancy) {
                return;
            }
            var addresses = [];
            for (var i = 0; i < vacancy.ITEMS.length; i++) {
                var v = vacancy.ITEMS[i];
                for (var a = 0; a < v.ADDRESSES_DATA.length; a++) {
                    var address = v.ADDRESSES_DATA[a];
                    address.vacancy_item_id = i;
                    addresses.push(address);
                }
            }
            addresses = _.uniqBy(addresses, "address");
            if (addresses.length == 1 && !vacancy.showSalary) {
                this.$set(vacancy, "showSalary", true);
            }
            return addresses;
        }
    }
});

Vue.component("vacancy-form", {
    props: {
        selectedRegion: {
            type: Number,
            default: null
        },
        selectedCity: {
            type: String,
            default: ""
        },
        selectedJobPlace: {
            type: String,
            default: ""
        },
        selectedDisplayMode: {
            type: String,
            default: ""
        },
        regions: {
            type: Array,
            default: () => []
        },
        cities: {
            type: Array,
            default: () => []
        },
        vacanciesData: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        region: null,
        selectedRegionName: "",
        city: "",
        jobPlace: "",
        displayMode: "list",
        displayModes: [{
                code: "list",
                text: "По профессиям"
            },
            {
                code: "map",
                text: "На карте"
            }
        ]
    }),
    mounted() {
        $(document).on("change", "select[name=\"REGION\"]", (e) => {
            this.region = $(e.currentTarget).val();
        });
        this.region = this.selectedRegion;
        this.city = this.selectedCity;
        this.jobPlace = this.selectedJobPlace;
        this.displayMode = this.selectedDisplayMode;
        var region = _.find(this.regions, { ID: this.region });
        if (region) {
            this.selectedRegionName = region.NAME;
        }
    },
    updated() {
        $("select[name=\"REGION\"]").selectize({
            onDropdownOpen: function(elem) {
                var selected_val = $(this.$control).find(".item").attr("data-value");
                this.default_val = selected_val;
                this.clear(true);
            },
            onDropdownClose: function(elem) {
                if (!this.getValue() && typeof(this.default_val) != "undefined") {
                    this.setValue(this.default_val);
                }
                $(this.$control).trigger("change");
            }
        });
    },
    watch: {
        jobPlace(val, oldVal) {
            vxCommonStore.commit("setVacanciesType", val);
        },
        region(val, oldVal) {
            var citiesInRegion = this.getCitiesInRegion(val);
            var region = _.find(this.regions, (region) => {
                return region.ID == this.region;
            });
            if (region) {
                this.selectedRegionName = region.NAME;
            }
            if (!_.find(citiesInRegion, { NAME: this.city })) {
                this.city = "";
            }
        },
        selectedShowMode: function() {

        }
    },
    methods: {
        getCountInCity(city) {
            var region = _.find(this.regions, { ID: city.IBLOCK_SECTION_ID });
            var vacanciesData = this.vacanciesData;
            var city_data = _.filter(vacanciesData, (item) => {
                return item.CITY == city.NAME && (item.REGION == this.selectedRegionName || !item.REGION);
            });
            var cnt = _.sum(_.map(city_data, function(a) {
                return parseInt(a.CNT);
            }));
            return cnt;
        },
        getPlacesInCity(city) {
            return _.uniq(_.filter(this.vacanciesData, {
                CITY: city,
                REGION: this.selectedRegionName
            }));
        },
        getCitiesInRegion(region) {
            return _.filter(this.cities, { IBLOCK_SECTION_ID: +region });
        },
        filterFormSubmit(e) {
            if (!this.jobPlace || !this.city) {
                e.preventDefault();
            }
        }
    }
});

Vue.component("catalog-top-filter", {
    data: () => ({
        pageCount: $("select[name=\"page_count\"]").val(),
        sortBy: $("select[name=\"sort_by\"]").val(),
        visible: false
    }),
    watch: {
        pageCount(val, oldVal) {
            $("#catalog_top_filter_form input[type=\"submit\"]").click();
        },
        sortBy(val, oldVal) {
            $("#catalog_top_filter_form input[type=\"submit\"]").click();
        }
    },
    mounted() {
        if ($(".catalog_container .catalog_product_item").length) {
            this.visible = true;
        }
    }
});

Vue.component("search-results", {
    props: {
        items: {
            type: Array,
            default: () => []
        },
        sections: {
            type: Array,
            default: () => []
        },
        iblocks: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        whereTypes: {}
    }),
    computed: {
        products() {
            var products = {};
            var whereTypes = ["name", "alter", "desc"];
            for (var i = 0; i < whereTypes.length; i++) {
                var items = _.filter(this.items, item => item.where == whereTypes[i] && item.iblockId == 9);
                if (items.length) {
                    products[whereTypes[i]] = {
                        items: items
                    };
                }
            }
            return products;
        },
        other() {
            var other = [];
            var iblockIds = _.filter(_.uniqBy(_.map(this.items, "iblockId")));
            for (var i = 0; i < iblockIds.length; i++) {
                var iblockId = iblockIds[i];
                var items = _.filter(this.items, item => item.iblockId == iblockId && item.iblockId != 9);
                if (items.length) {
                    other.push({
                        iblockId: iblockId,
                        iblock: _.find(this.iblocks, iblockInfo => iblockInfo.ID == iblockId),
                        items: items
                    });
                }
            }
            return other;
        }
    },
    beforeMount() {
        var whereTypes = _.filter(_.uniqBy(_.map(this.items, "where")));
        var iblockIds = _.filter(_.uniqBy(_.map(this.items, "iblockId")));
        for (var i = 0; i < whereTypes.length; i++) {
            this.whereTypes[whereTypes[i]] = {
                visibleCnt: 10
            };
        }
        for (var i = 0; i < iblockIds.length; i++) {
            this.whereTypes[iblockIds[i]] = {
                visibleCnt: 10
            };
        }
    },
    mounted() {
        if (!this.items.length && !this.sections.length) {
            setTimeout(
                function() {
                    if (typeof(window.yaCounter15466654) != "undefined") {
                        window.yaCounter15466654.reachGoal("nosearchresults");
                    }
                },
                1500
            );
        }
    },
    methods: {
        getPluralize (num, a, b, c) {
            return getPluralize(num, a, b, c);
        },
        incVisibleCnt(code) {
            if (!this.whereTypes[code]) {
                return;
            }
            this.whereTypes[code].visibleCnt += 10;
            this.$forceUpdate();
        }
    }
});

Vue.component("order-form", {
    props: {
        formUrl: {
            type: String,
            default: ""
        }
    },
    store: vxCommonStore,
    computed: {
        mainShop: () => vxCommonStore.state.mainShop,
        cartData: () => vxCommonStore.state.cartData,
        cartDataJson() {
            return JSON.stringify(this.cartData);
        },
        corpOrder() { //замена
            return this.$store.state.corpOrder;
        },
        cartItemsData() {
            return this.$store.state.cartItemsData;
        },
        cartTotal: () => {
            let sum = vxCommonStore.state.cartTotal;
            return sum;
        },
        shopAlcoholTime: () => vxCommonStore.state.shopAlcoholTime,
        minOrderSum() {
            // if (this.cartData.tare && this.cartData.tare.length) {
            //     return 600;
            // }
            if (_.isEmpty(vxCommonStore.state.shopsData)) {
                vxCommonStore.commit("loadShops");
            }
            return 500;
        },
        schedulleArray() {
            if (_.isEmpty(vxCommonStore.state.shopsData)) {
                vxCommonStore.commit("loadShops");
            }
            let alcTime = this.$root.selectedShop.alcTime;
            let arAlcTime = [];
            let i = 0;
            if ((alcTime.sunday[0] === null && alcTime.sunday[1] === null)) {
                if (alcTime.week[0] == alcTime.weekend[0] && alcTime.week[1] == alcTime.weekend[1]) {
                    arAlcTime[i++] = "пн - вс " + alcTime.week[0] + " - " + alcTime.week[1];
                } else {
                    arAlcTime[i++] = "пн - пт " + alcTime.week[0] + " - " + alcTime.week[1];
                    arAlcTime[i++] = "сб - вс " + alcTime.weekend[0] + " - " + alcTime.weekend[1];
                }
            } else {
                if ((alcTime.week[0] == alcTime.weekend[0] && alcTime.week[1] == alcTime.weekend[1]) && (alcTime.week[0] == alcTime.sunday[0] && alcTime.week[1] == alcTime.sunday[1])) {
                    arAlcTime[i++] = "пн - вс " + alcTime.week[0] + " - " + alcTime.week[1];
                } else {
                    if (alcTime.week[0] == alcTime.weekend[0] && alcTime.week[1] == alcTime.weekend[1]) {
                        arAlcTime[i++] = "пн - cб " + alcTime.week[0] + " - " + alcTime.week[1];
                    } else {
                        arAlcTime[i++] = "пн - пт " + alcTime.week[0] + " - " + alcTime.week[1];
                        arAlcTime[i++] = "сб " + alcTime.weekend[0] + " - " + alcTime.weekend[1];
                    }
                    arAlcTime[i++] = "вс " + alcTime.sunday[0] + " - " + alcTime.sunday[1];
                }
            }
            return arAlcTime;
            //return ['trtew','werwerwe'];

        },
        isVisibleOrder(){
            //let per = (+cartTotal >= +minOrderSum);
            //console.log(per,'per');
            //return false;
            return (+this.cartTotal >= +this.minOrderSum);
        }
    },
    data: () => ({
        ajaxProcessed: false,
        orderDateTime: "",
        checkedGrusopodyemnost: false,
        checkedInn: false,
        textIndividual: false,
        inn: null,
        errorFields: [],
        errorMessages: [],
        maxOrderSum: 100000,
        formFields: {},
        typeCompany: null,
        isVisibleForm: false
    }),
    watch: {
        orderDateTime(val, oldVal) {
            if (this.shopAlcoholTime) {
                var mSelectedDate = moment(val, "HH:mm DD.MM.YYYY");
                var dayOfWeek = mSelectedDate.isoWeekday();
                var alcoTime;
                if (dayOfWeek < 6) {
                    alcoTime = this.shopAlcoholTime.week;
                } else if (dayOfWeek == 6) {
                    alcoTime = this.shopAlcoholTime.weekend;
                }
                if (dayOfWeek == 7) {
                    alcoTime = this.shopAlcoholTime.sunday;
                }
                if (!alcoTime) {
                    return;
                }
                var mSelectedDateStart;
                var mSelectedDateEnd;
                if (alcoTime.start) {
                    mSelectedDateStart = moment(alcoTime.start + " " + mSelectedDate.format("DD.MM.YYYY"), "HH:mm DD.MM.YYYY");
                }
                if (alcoTime.end) {
                    mSelectedDateEnd = moment(alcoTime.end + " " + mSelectedDate.format("DD.MM.YYYY"), "HH:mm DD.MM.YYYY");
                }
                if (
                    (mSelectedDateStart && mSelectedDate.diff(mSelectedDateStart, "minute") < 0) ||
                    (mSelectedDateEnd && mSelectedDate.diff(mSelectedDateEnd, "minute") > 0)
                ) {
                    var text = _.template(" \
                    В Вашем регионе продажа алкоголя осуществляется \
                    <% if (start) { %> с <%- start %> <% } %>  \
                    <% if (end) { %> до <%- end %> <% } %>  \
                    . Пожалуйста, измените время бронирования. \
                    ")({
                        start: mSelectedDateStart ? mSelectedDateStart.format("HH:mm") : null,
                        end: mSelectedDateEnd ? mSelectedDateEnd.format("HH:mm") : null
                    });
                    showHeaderMessage(text, "error");
                }
            }
        }
    },
    mounted() {
        if (this.$root.minOrderSum != false && this.cartTotal < this.$root.minOrderSum) {
            $("body").addClass("not_enough_cart_total");
        } else {
            $("body").removeClass("not_enough_cart_total");
        }

        $(document).on("change", "#ORDER_PROP_34, input[name=type-company]", (e) => {
            let inn = $("#ORDER_PROP_34").val();
            if (inn.length > 0) {
                let validGetDataCompany = true;
                let messageError = "";
                if (this.typeCompany == "ip" && inn.length != 12) {
                    messageError = "Введите правильный ИНН индивидуального предпринимателя";
                    validGetDataCompany = false;
                }
                if (this.typeCompany == "ooo" && inn.length != 10) {
                    messageError = "Введите правильный ИНН юридического лица";
                    validGetDataCompany = false;
                }

                if (validGetDataCompany === true) {
                    let body = new FormData;
                    body.append("ajax_command", "innDadata");
                    body.append("inn", inn);
                    body.append("z", "1");
                    this.inn = inn;
                    fetch("/local/php_interface/ajax/", {
                            method: "POST",
                            body
                        })
                        .then(response => response.json())
                        .then(json => {
                            if (json.success == true) {
                                this.$store.state.corpOrderInn = inn;
                                if (json.result.suggestions.length > 0) {
                                    if (json.result.suggestions[0].data.type == "INDIVIDUAL") {
                                        document.getElementById("ORDER_PROP_32").removeAttribute("readonly");
                                        document.getElementById("ORDER_PROP_33").removeAttribute("required");
                                        document.getElementById("ORDER_PROP_35").removeAttribute("required");
                                        this.textIndividual = true;
                                    } else if (json.result.suggestions[0].data.type == "LEGAL") {
                                        document.getElementById("ORDER_PROP_32").setAttribute("readonly", "readonly");
                                        document.getElementById("ORDER_PROP_33").setAttribute("required", "required");
                                        document.getElementById("ORDER_PROP_35").setAttribute("required", "required");
                                        this.textIndividual = false;
                                    } else {
                                        this.textIndividual = false;
                                    }
                                    $("#ORDER_PROP_31").val(json.result.suggestions[0].data.name.short_with_opf);
                                    if(json.result.suggestions[0].data && json.result.suggestions[0].data.address && json.result.suggestions[0].data.address.value)
                                        {
                                            $("#ORDER_PROP_32").val(json.result.suggestions[ 0 ].data.address.value);
                                        }
                                    if (json.result.suggestions[0].data.management) {
                                        $("#ORDER_PROP_33").val(json.result.suggestions[0].data.management.name);
                                    } else {
                                        $("#ORDER_PROP_33").val("");
                                    }
                                    if (json.result.suggestions[0].data.kpp) {
                                        $("#ORDER_PROP_35").val(json.result.suggestions[0].data.kpp);
                                    } else {
                                        $("#ORDER_PROP_35").val("");
                                    }
                                    this.checkedInn = true;
                                    console.log('1');
                                    if (json.result.updateBasket == true) {
                                        this.$refs.deleteItemsInnMsgPopup.open()
                                            .then(action => {
                                                if (action == "confirm") {
                                                    //эта запись перезагрузит корзину
                                                    let bodyInn = new FormData;
                                                    bodyInn.append("ajax_command", "deleteProductNotInn");
                                                    bodyInn.append("inn", $("#ORDER_PROP_34").val());
                                                    bodyInn.append("z", "1");
                                                    fetch("/local/php_interface/ajax/", {
                                                            method: "POST",
                                                            body: bodyInn
                                                        })
                                                        .then(response => response.json())
                                                        .then(json => {
                                                            if (json.success == true) {
                                                                this.$parent.$refs.basket.update();
                                                            }
                                                        });
                                                } else {
                                                    $("#ORDER_PROP_31").val("");
                                                    $("#ORDER_PROP_34").val("");
                                                    $("#ORDER_PROP_32").val("");
                                                    $("#ORDER_PROP_33").val("");
                                                    $("#ORDER_PROP_35").val("");
                                                    let bodyInn = new FormData;
                                                    bodyInn.append("ajax_command", "clearSessionInn");
                                                    bodyInn.append("z", "1");
                                                    fetch("/local/php_interface/ajax/", {
                                                            method: "POST",
                                                            body: bodyInn
                                                        })
                                                        .then(response => response.json())
                                                        .then(json => {
                                                            if (json.success == true) {
                                                                this.$parent.$refs.basket.update();
                                                            }
                                                        });
                                                    this.$parent.$refs.basket.update();
                                                    console.log('2');
                                                    this.checkedInn = false;
                                                }
                                            });
                                    } else {

                                    }
                                } else {
                                    //эта запись перезагрузит корзину
                                    this.$parent.$refs.basket.update();
                                    $("#ORDER_PROP_31").val("");
                                    $("#ORDER_PROP_34").val("");
                                    $("#ORDER_PROP_32").val("");
                                    $("#ORDER_PROP_33").val("");
                                    $("#ORDER_PROP_35").val("");
                                    showHeaderMessage("Информация о предприятии не найдена", "error");
                                    this.checkedInn = false;
                                }
                            } else {
                                //эта запись перезагрузит корзину
                                $("#ORDER_PROP_31").val("");
                                $("#ORDER_PROP_32").val("");
                                $("#ORDER_PROP_33").val("");
                                $("#ORDER_PROP_35").val("");
                                showHeaderMessage("Информация о предприятии не найдена", "error");
                                this.checkedInn = false;
                            }
                        })
                        .catch(console.error)
                        .finally(() => {

                        });
                } else {
                    //эта запись перезагрузит корзину
                    $("#ORDER_PROP_31").val("");
                    $("#ORDER_PROP_32").val("");
                    $("#ORDER_PROP_33").val("");
                    $("#ORDER_PROP_35").val("");
                    showHeaderMessage(messageError, "error");
                    this.checkedInn = false;
                }
            }
        });

        $(document).on("click", "#ORDER_PROP_20", (e) => {
            if (!$("#order_date_calendar .ic__container").length) {

                var todayDate = moment();
                var ionStartDate = todayDate.format("DD.MM.YYYY");

                if (todayDate.hour() >= 22) {
                    ionStartDate = todayDate.add(1, "days").format("DD.MM.YYYY");
                }

                $("#order_date_calendar").ionCalendar({
                    lang: "ru",
                    sundayFirst: false,
                    years: "5",
                    format: "DD.MM.YYYY",
                    hideArrows: true,
                    startDate: ionStartDate,
                    onClick: (date) => {
                        window.cart_calendar_hours = $(".ic__time-select").val();

                        var curDate = moment();
                        curDate.locale("ru");
                        curDate.minute(0);
                        curDate.second(0);
                        curDate.millisecond(0);

                        var selectedDate = moment(date, "DD.MM.YYYY");
                        selectedDate.locale("ru");
                        selectedDate.hour(window.cart_calendar_hours);
                        //   selectedDate.hour(0);
                        selectedDate.minute(0);
                        selectedDate.second(0);
                        selectedDate.millisecond(0);

                        if (selectedDate.diff(curDate, "hours") < 1) {
                            selectedDate.hour(moment().add(1, "hour").format("H"));
                        }

                        var date = selectedDate.format("HH:mm DD.MM.YYYY");
                        //   date = selectedDate.format("DD.MM.YYYY");

                        if ((selectedDate.diff(curDate, "hours") < 1) || (selectedDate.diff(curDate, "days") > 1)) {
                            showHeaderMessage("Заказ можно оформить только на сегодня и завтра c 9:00 до 22:00", "error");
                            return false;
                        }

                        $(".order_date_calendar_widget").toggle();
                        this.orderDateTime = date;
                    },
                    onReady: (date) => {
                        var selectedDate = moment(date, "DD.MM.YYYY");
                        var curDate = moment();

                        if (typeof(window.cart_calendar_hours) != "undefined") {
                            curDate.hour(window.cart_calendar_hours);
                        } else {
                            curDate.add(1, "hour");
                        }
                        var dt = moment();
                        var html = "<div class=\"ic__time\"><select class=\"ic__time-select\">";
                        for (var i = 9; i < 23; i++) {
                            if ((i < parseInt(moment().add(1, "hour").format("H"))) && (selectedDate.format("DD") == moment().format("DD"))) {
                                continue;
                            }
                            if (i === parseInt(curDate.format("H"))) {
                                html += "<option value=\"" + i + "\" selected=\"selected\">" + dt.hour(i).format("H") + ":00</option>";
                            } else {
                                html += "<option value=\"" + i + "\">" + dt.hour(i).format("H") + ":00</option>";
                            }
                        }
                        html += "</select></div>";
                        $(".ic__header").append(html);

                        $(".ic__time-select").change((e) => {
                            var hour = $(e.currentTarget).val();
                            var date = this.orderDateTime;
                            if (date == "") {
                                date = moment().format("HH:mm DD.MM.YYYY");
                            }
                            var selectedDate = moment(date, "HH:mm DD.MM.YYYY");
                            selectedDate.hour(hour);
                            selectedDate.minute(0);
                            selectedDate.second(0);
                            this.orderDateTime = selectedDate.format("HH:mm DD.MM.YYYY");
                        });
                    }
                });
            }
            $(".order_date_calendar_widget").toggle();
        });
    },
    updated() {
        $("[name=\"ORDER_PROP_3\"]").each(function() {
            if ($(this).val().length) {
                var phone = $(this).val().match(/\d+/ig).join("");
                if (phone.length >= 11) {
                    phone = phone.substr(1, (phone.length - 1));
                    $(this).val(phone);
                }
            }
            $(this).inputmask({
                mask: !is.android() ? "+7 (999) 999-99-99" : "+79999999999"
            });
        });
    },
    methods: {
        hidePropClass(fieldName) {
            if (!this.typeCompany) { return false; }
            if (this.typeCompany == "ip") {
                if (
                    fieldName == "ORDER_PROP_33" ||
                    fieldName == "ORDER_PROP_35"
                ) {
                    return false;
                }
            }
            return true;
        },
        onCorpOrderFormChange(field, val) {
            //console.log(field, val);
        },
        submit(val) {
            if (this.corpOrder && !this.checkedInn) {
                window.showHeaderMessage("Информация о предприятии не найдена", "error");
                return;
            }
            var data = $("form#ORDER_FORM").serializeArray();
            if (val != "Y") {
                _.find(data, { name: "confirmorder" }).value = "N";
            }
            this.ajaxProcessed = true;
            if (!data.length) {
                return;
            }
            $.ajax({
                url: this.formUrl,
                type: "post",
                dataType: "json",
                data: data,
                complete: (xhr) => {
                    var res = xhr.responseText;
                    this.ajaxProcessed = false;
                    try {
                        var json = JSON.parse(res);
                        console.log(json);
                        if (json.errorMessages || json.errorProps) {
                            this.errorMessages = json.errorMessages || [];
                            var errorFields = json.errorFields || [];
                            errorFields = _.map(errorFields, propId => +propId);
                            this.errorFields = errorFields;
                            window.showHeaderMessage("Заполните обязательные поля", "error");
                            return;
                        } else if (json.redirect) {
                            if (typeof(window.yaCounter15466654) != "undefined") {
                                window.yaCounter15466654.reachGoal("orderfromcart");
                            }
                            location.href = json.redirect;
                        }
                    } catch (e) {
                        $("#order_form_content").html(res);
                        if ($("#ORDER_FORM .errors").length) {
                            $("html,body").animate({
                                    scrollTop: $("#ORDER_FORM .errors").offset().top
                                },
                                100
                            );
                            if (typeof(window.showHeaderMessage) != "undefined") {
                                window.showHeaderMessage("Заполните обязательные поля", "error");
                            }
                        }
                    }
                }
            });
        },
        submitForm(val) {
            if (+this.cartTotal > +this.maxOrderSum && (!this.corpOrder)) {
                window.showHeaderMessage(`Максимальная сумма заказа - ${this.maxOrderSum}`, "error");
                return;
            }
            if (document.querySelector(".basket-unavailable_items")) {
                this.$refs.delayedItemsMsgPopup.open()
                    .then(action => {
                        if (action == "confirm") {
                            this.submit(val);
                        }
                    });
            } else {
                this.submit(val);
            }
        },
        visibilityChanged (isVisible, entry) {
            this.isVisibleForm = isVisible;
        },
        scrollToForm(){
            let form = event.target.closest("form");
            form.scrollIntoView();
        },
        validateForm(){

            let form = event.target.closest("form");
            let valid = true;
            form.querySelectorAll("input, textarea").forEach((input) => {
                if(input.closest(".od-fields__left-row"))
                    {
                        if( input.checkValidity() )
                            {
                                input.closest(".od-fields__left-row").classList.remove("error");
                            }
                        else
                            {
                                input.closest(".od-fields__left-row").classList.add("error");
                                valid=false;
                            }
                    }
            });
            if(valid !== true){
                event.preventDefault();
            }
            return valid;
        }
    }
});

if (window.frameCacheVars !== undefined) {
    console.log('onFrameDataReceived1')
    BX.addCustomEvent("onFrameDataReceived", function(json) {
        console.log('onFrameDataReceived')
        afterCompositeLoaded();
    });
} else {

    // if (window.BX) {
    //     BX.ready(() => {
    //         afterCompositeLoaded();
    //     });
    // }
    // else {
    //     $(function(){
    //         afterCompositeLoaded();
    //     });
    // }
    document.addEventListener('DOMContentLoaded', afterCompositeLoaded);
}

BX.addCustomEvent("onFrameDataRequestFail", function(response) {
    if (~window.location.href.indexOf("?")) {
        window.location.href = window.location.href + "&ncc=1";
    } else {
        window.location.href = window.location.href + "?ncc=1";
    }
});

function afterCompositeLoaded() {
    window.vmApp = new Vue({
        el: "#main",
        store: vxCommonStore,
        mounted() {
            //выберем город во всех формах
            requestAnimationFrame(() => {
                let selects = document.querySelectorAll("[data-select-type=\"city\"]");
                selects && selects.forEach(select => {
                    if (select.options && this.userCity) {
                        Array.from(select.options).forEach(opt => {
                            if (opt.value === this.userCity) {
                                opt.selected = true;
                                this.regionFormId = opt.getAttribute("data-parent");
                            }
                        });
                    }
                });

                let selectsRegion = document.querySelectorAll("[data-select-type=\"region\"]");
                (this.regionFormId > 0) && selectsRegion && selectsRegion.forEach(select => {
                    if (select.options && this.regionFormId) {
                        Array.from(select.options).forEach(opt => {
                            if (opt.value === this.regionFormId) {
                                opt.selected = true;
                            }
                        });
                    }
                });
                if (selectsRegion) {
                    this.selectRegion(this.regionFormId);
                }
            });
            $("body").on("click", ".form_row__show-pass", function(e) {
                e.preventDefault();

                const $targetPasswordInput = $(this).closest(".form_row").find("input[id*='PASSWORD']").length ?
                    $(this).closest(".form_row").find("input[id*='PASSWORD']") :
                    $(this).closest(".form_row").find("input[name*='PASSWORD']");

                if ($targetPasswordInput.attr("type") == "password") {
                    $targetPasswordInput.attr("type", "text");
                } else {
                    $targetPasswordInput.attr("type", "password");
                }
            });


            if (vxCommonStore.state.ageConfirmed && !vxCommonStore.state.isCityConfirmed && !this.isMobile) {
                $(() => {
                    this.showCitySelect();
                });
            }

            if (this.userDevice == "desktop") {
                $("input.card_num").inputmask("2  020999  999999");
            }

            $(".selectize[name=\"PROPERTY[214][0]\"]").selectize({
                onDropdownOpen: function(elem) {
                    var selected_val = $(this.$control).find(".item").attr("data-value");
                    this.default_val = selected_val;
                    this.clear(true);
                },
                onDropdownClose: function(elem) {
                    if (!this.getValue() && typeof(this.default_val) != "undefined") {
                        this.setValue(this.default_val);
                    }
                    $(this.$control).trigger("change");
                }
            });
            if ($("body.page_discount .item_bl_question--discount").length) {
                var discountPromoText = $("body.page_discount .item_bl_question--discount .item_bl_question_cont").html();
                discountPromoText = discountPromoText.replace("#PROMO_CODE#", vxCommonStore.state.promo.discountPageCode);
                discountPromoText = discountPromoText.replace("#PROMO_DATE_TO#", vxCommonStore.state.promo.dateTo);
                $("body.page_discount .item_bl_question--discount .item_bl_question_cont").html(discountPromoText);
            }
            setPhoneMask("input[name=\"PROPERTY[360][0]\"]");
            $("input[name=\"PROPERTY[361][0]\"]").attr("type", "email");
            if (window.location.hash == "#feedback") {
                setTimeout(
                    () => {
                        $.fancybox({
                            href: "#write_letter_popup",
                            helpers: {
                                title: {
                                    type: "inside"
                                }
                            },
                            beforeShow() {
                                $("body").addClass("fancybox-active");
                            },
                            afterShow() {
                                if ($("body").hasClass("mobile")) {
                                    window.scrollTo(0, 0);
                                }
                            },
                            afterClose() {
                                $("body").removeClass("fancybox-active");
                            }
                        });
                    },
                    2000
                );
            }

            $(".bl_rob_p__name").each((i, el) => {
                var $this = $(el);

                var degName = $this.text(),
                    name = "";

                degName = degName.split(" ");

                for (var i in degName) {
                    var deg = degName[i];

                    name += deg + " <br />";
                }

                $this.html(name);

            });

            this.initRotate3dPics();

            $("#calc-result .product_item_images").height(Math.max.apply(null,
                $("#calc-result .product_item_images").map(function() {
                    return $(this).height();
                })));

            /*if (localStorage && _.isEmpty(vxCommonStore.state.regionsData)) {
             vxCommonStore.commit('loadRegionsData');
             }
             if (localStorage && _.isEmpty(vxCommonStore.state.shopsData)) {
             vxCommonStore.commit('loadShops');
             }*/

            vxCommonStore.commit("setShopsInSelectedCity");

            this.setBodyClasses();
            if (typeof(window.header_message) != "undefined") {
                showHeaderMessage(window.header_message.message, window.header_message.status, window.header_message.delay);
            }

            $(".slick-cloned.fancybox, .slick-cloned .fancybox").removeAttr("rel").removeClass("fancybox");
            $(".slick-cloned.fancybox_pad30, .slick-cloned .fancybox_pad30").removeAttr("rel").removeClass("fancybox_pad30");

            $("[data-fancybox]").fancybox({
                beforeShow() {
                    $("body").addClass("get-price-popup-active");
                },
                afterClose() {
                    $("body").removeClass("get-price-popup-active");
                }
            });
            $(".fancybox").fancybox({
                beforeShow() {
                    $("body").addClass("fancybox-active");
                },
                afterShow() {
                    if ($("body").hasClass("mobile")) {
                        window.scrollTo(0, 0);
                    }
                },
                afterClose() {
                    $("body").removeClass("fancybox-active");
                }
            });
            // SMALL INFO MODALS
            $(".modal-info").fancybox({
                closeBtn: true,
                wrapCSS: 'fancybox-wrap--compact',
                helpers : { overlay: {opacity: 1,css: {'background': 'rgba(0,0,0,0.88)'}}}
            });
            window.openCompactModal = function (modalId) {
                window.$.fancybox({
                    href: `#${modalId}`,
                    closeBtn: true,
                    wrapCSS: 'fancybox-wrap--compact',
                    helpers : { overlay: {opacity: 1,css: {'background': 'rgba(0,0,0,0.88)'}}}
                })
            };
            $(".fancybox_pad30").fancybox({
                beforeShow() {
                    $("body").addClass("fancybox-active");
                },
                afterShow() {
                    if ($("body").hasClass("mobile")) {
                        window.scrollTo(0, 0);
                    }
                },
                afterClose() {
                    $("body").removeClass("fancybox-active");
                }
            });
            $(document).on("change", "#catalog-filter-form input, #catalog-filter-form select", function(e) {
                if ($(this).hasClass("filter_search")) {
                    return;
                }
                if(document.body.clientWidth > 1024)
                    {
                        $("#catalog-filter-form [type=\"submit\"]").click();
                    }
            });
            $(".mask-phone, [name=\"ORDER_PROP_3\"], [name=\"PROPERTY[213][0]\"], input[name=\"phone\"]").each(function() {
                if ($(this).val().length) {
                    var phone = $(this).val().match(/\d+/ig).join("");
                    if (phone.length >= 11) {
                        phone = phone.substr(1, (phone.length - 1));
                        $(this).val(phone);
                    }
                }
                $(this).inputmask({
                    mask: !is.android() ? "+7 (999) 999-99-99" : "+79999999999"
                });
            });
            $(".mask-date").inputmask("99.99.9999");
            $(".mask-datetime").inputmask("99:99 99.99.9999", {});

            if ($(".soc--show_widget").length) {
                $(".soc--show_widget").hover(
                    function(e) {
                        var $widget;
                        if ($(this).hasClass("soc--vk")) {
                            $widget = $("<div/>")
                                .addClass("soc_widget_popup");
                            $widget.html(vk_widget_script);
                            $(this).append($widget);
                        }
                        if ($(this).hasClass("soc--ok")) {
                            $widget = $("<div/>")
                                .addClass("soc_widget_popup");
                            $widget.html(ok_widget_script);
                            $(this).append($widget);
                        }
                        if ($(this).hasClass("soc--instagram")) {
                            $widget = $("<div/>")
                                .addClass("soc_widget_popup");
                            $widget.html(instagram_widget_script);
                            $(this).append($widget);
                        }
                        if ($(this).hasClass("soc--facebook")) {
                            $widget = $("<div/>")
                                .addClass("soc_widget_popup");
                            $widget.html(facebook_widget_script);
                            $(this).append($widget);
                        }
                    },
                    function(e) {
                        $(this).find(".soc_widget_popup").remove();
                    }
                );
            }

            $(document).on("submit", "form.discount-check", function(e) {
                e.preventDefault();
                var data = $(this).serializeArray();
                data.push({
                    name: "card_submit",
                    value: "Y"
                });
                $.ajax({
                    type: "post",
                    url: $(this).attr("action"),
                    data: data,
                    success(response) {
                        $(".bl_enter_nomer_inf").html(response);
                    }
                });
                return false;
            });

            $(".slider-range").each(function() {
                var min = parseFloat($(this).attr("data-min-val"));
                var max = parseFloat($(this).attr("data-max-val"));
                var minRange = parseFloat($(this).attr("data-min-range"));
                var maxRange = parseFloat($(this).attr("data-max-range"));


                var step = 1;
                if ($(this).attr("data-step")) {
                    step = parseFloat($(this).attr("data-step"));
                }
                var inputMin = $("#" + $(this).attr("data-input-min"));
                var inputMax = $("#" + $(this).attr("data-input-max"));

                $(this).slider({
                    range: true,
                    step: step,
                    min: 0,
                    max: maxRange,
                    values: [min, max],
                    slide: function(event, ui) {
                        $(inputMin).val(ui.values[0]);
                        $(inputMax).val(ui.values[1]);
                    },
                    change: function(event, ui) {
                        $(inputMin).trigger("change");
                    }
                });
            });


            $(".c-calculator__slider #quantity").each(function() {

                $("#quantity").slider({
                    range: "max",
                    min: 3,
                    max: 20,
                    step: 1,
                    slide: function(event, ui) {
                        $(".c-calculator__slider-result.quantity span").text(ui.value);
                    }
                });
            });

            $(".c-calculator__slider #duration").each(function() {
                $("#duration").slider({
                    range: "max",
                    min: 1,
                    max: 24,
                    step: 1,
                    slide: function(event, ui) {
                        $(".c-calculator__slider-result.duration span").text(ui.value);
                    }
                });
            });

            $(".c-calculator__slider #sum").each(function() {
                $("#sum").slider({
                    range: "min",
                    min: 1,
                    max: 3,
                    step: 1
                });
            });

            $(".components__slider .c-slider").slick({
                arrows: true,
                dots: false,
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: true
            });


            if (typeof(readyTest) == "function") {
                readyTest();
            }

            if ($("body.mobile").length) {
                $(document).on("click", ".btn_show_hide_filter", function() {
                    if (!$("#catalog-filter-form").is(":visible")) {
                        Cookies.set("mobile_catalog_filter_visible", 1);
                        $("#catalog-filter-form").slideDown();
                    } else {
                        Cookies.set("mobile_catalog_filter_visible", 0);
                        $("#catalog-filter-form").slideUp();
                    }
                });
                if (Cookies.get("mobile_catalog_filter_visible") == 1) {
                    $("#catalog-filter-form").slideDown();
                }
            }

            $(document).on("click", ".catalog_container--bestsellers .catalog_product_item", () => {
                if (yaCounter15466654) {
                    yaCounter15466654.reachGoal("tovarKup");
                }
            });
            $(document).on("click", ".catalog_container--related .catalog_product_item", () => {
                if (yaCounter15466654) {
                    yaCounter15466654.reachGoal("soptoVary");
                }
            });

            if (is.touchDevice()) {
                let tag = document.createElement("style");
                tag.innerHTML = "@media screen and (max-width: 812px) and (max-height:" + ($(window).height() - 10) + "px){\
                    body.fancybox-active.mobile .popup_bottom_bl{\
                        position: static !important;\
                    }\
                    \
                    body.fancybox-active.mobile div.popup_cont{\
                        padding-bottom: 20px !important;\
                    }\
                }";
                document.body.appendChild(tag);
            }

            setTimeout(() =>{
                if (window.location.hash.includes('#merch-popup')) {
                    this.$refs.merchFormPopup.open()
                }
                if (window.location.hash.includes('#video-popup')) {
                    this.$refs.feedbackVideoForm.open()
                }
            },1000)
            
            // Проверка доступности пунктов меню
            checkAvailableMenuItem();
        },
        data: {
            ageConfirmationRejected: false,
            compositeLoaded: true,
            isLoading: false,
            iosLink: "https://redirect.appmetrica.yandex.com/serve/97098921012107917",
            androidLink: "https://redirect.appmetrica.yandex.com/serve/313271697136424480",
            tests: [],
            regionFormId: null,
        },
        computed: {
            productDetailReviewsCnt: () => vxCommonStore.state.productDetailReviewsCnt,
            mainShop: () => vxCommonStore.state.mainShop,
            isMobile: () => is.mobile(),
            cartTotal: () => vxCommonStore.state.cartTotal,
            ageConfirmed: () => vxCommonStore.state.ageConfirmed,
            isCityConfirmed: () => vxCommonStore.state.isCityConfirmed,
            userCityId: () => vxCommonStore.state.userCityId,
            favoriteShops: () => vxCommonStore.state.favoriteShops,
            catalogUploadTimestamp: () => vxCommonStore.state.catalogUploadTimestamp,
            userDevice: () => vxCommonStore.state.userDevice,
            userId: () => vxCommonStore.state.userId,
            isViewportDisabled: () => vxCommonStore.state.isViewportDisabled,
            userCity() {
                return this.$store.state.userCity || "";
            },
            mobileAppLink() {
                return is.ios() ? this.iosLink : this.androidLink;
            },
            isNonAlcoholShop() {
                try {
                    if (this.selectedShop.noAlcohol) {
                        return true;
                    }
                } catch (e) {

                }
                return false;
            },
            selectedShop() {
                try {
                    if (!this.$store.state.mainShop.shopNum) {
                        return {};
                    }
                    return this.$store.state.shopsData.find(o => o.shopNum == this.$store.state.mainShop.shopNum) || {};
                } catch (e) {

                }
                return {};
            },
            selectedShopSheduleMismatch() {
                let mismatch = false;
                if (this.selectedShop.alcTime) {
                    for (var k in this.selectedShop.alcTime) {
                        let workTime = this.selectedShop.workTime[k] || this.selectedShop.workTime.week;
                        let workFrom = (workTime[0] || "").split(":").map(v => +v || 0);
                        let workTo = (workTime[1] || "").split(":").map(v => +v || 0);
                        let alcFrom = (this.selectedShop.alcTime[k][0] || "").split(":").map(v => +v || 0);
                        let alcTo = (this.selectedShop.alcTime[k][1] || "").split(":").map(v => +v || 0);
                        if (
                            alcFrom && alcFrom > workFrom ||
                            alcTo && alcTo < workTo
                        ) {
                            mismatch = true;
                            break;
                        }
                    }
                }
                return mismatch;
            }
        },
        watch: {
            userDevice(val, oldVal) {
                this.setBodyClasses();
            },
            userId(val, oldVal) {
                this.setBodyClasses();
            }
        },
        methods: {
            removeUser()
                {
                    this.$refs.personalProfileEdit.removeUser();
                },
            findGetParameter(parameterName) {
                let result = null,
                    tmp = [];
                location.search
                    .substr(1)
                    .split("&")
                    .forEach(function(item) {
                        tmp = item.split("=");
                        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                    });
                return result;
            },
            initMap(callback) {
                if (!window.ymaps) {
                    var script = document.createElement("script");
                    script.src = "https://api-maps.yandex.ru/2.1/?lang=ru_RU";
                    if (typeof(callback) == "function") {
                        script.onload = callback;
                    }
                    document.body.appendChild(script);
                } else {
                    if (typeof(callback) == "function") {
                        callback();
                    }
                }
            },
            initRotate3dPics() {
                if (typeof($().threesixty) != "function") {
                    return;
                }
                $(".fancybox-3d").fancybox({
                    beforeShow() {
                        $("body").addClass("popup-3d-open").addClass("fancybox-active");
                    },
                    afterShow() {
                        var imgArr = $(".popup-3d .pr_card_images__rotate-imgs").data("imgs") || [];

                        $("#rotate-img-popup").threesixty({
                            images: imgArr,
                            method: "click",
                            "cycle": 2,
                            direction: "backward"
                        });
                    },
                    afterClose() {
                        $("body").removeClass("popup-3d-open").removeClass("fancybox-active");
                    }
                });

                var imgArr_ = $(".pr_card_images_slide--360 > .pr_card_images__rotate-imgs").data("imgs") || [];

                $("#rotate-img").threesixty({
                    images: imgArr_,
                    method: "click",
                    "cycle": 2,
                    direction: "backward"
                });
            },
            setBodyClasses() {
                if (+this.userId) {
                    $("body").addClass("authorized");
                    $("body").removeClass("non_authorized");
                } else {
                    $("body").addClass("non_authorized");
                    $("body").removeClass("authorized");
                }
                if (!this.isViewportDisabled) {
                    $("body").addClass(this.userDevice);
                }
            },
            showProductAvailableShops() {
                this.$refs.productDetailTabs.setActiveTabCode("shops_list");
                $("html, body").animate({ scrollTop: $(".pr_card_tabs_head").offset().top }, 1000);
            },
            showCitySelect() {
                if (this.$refs.citySelectPopup) {
                    this.$refs.citySelectPopup.open();
                }
            },
            onAgeConfirmed() {
                /*if (!this.isMobile) {
                 this.showCitySelect();
                 }*/
            },
            url(url = "") {
                location.href = url;
            },
            selectShop(id) {
                if (!vxCommonStore.state.shopsData || !vxCommonStore.state.shopsData.length) {
                    return;
                }
                var shop = _.find(vxCommonStore.state.shopsData, item => item.id == id);
                vxCommonStore.commit("setMainShop", shop);
            },
            changeRegionForm() {
                this.selectRegion(event.target.value);
            },
            selectRegion(id) {
                this.regionFormId = id;
                let cityOptions = document.querySelectorAll("[data-select-type=\"city\"]");
                let selectedCity = false;
                cityOptions && cityOptions.forEach(select => {
                    if (select.options) {
                        Array.from(select.options).forEach(opt => {
                            opt.selected = false;
                            if (opt.getAttribute("data-parent") === this.regionFormId) {
                                opt.style.display = "block";
                                if (this.userCity && opt.value === this.userCity) {
                                    opt.selected = true;
                                    selectedCity = true;
                                    document.querySelector('input[name=\'regionId\']').value = opt.getAttribute("data-parent");
                                }

                            } else {
                                opt.style.display = "none";
                            }
                        });
                    }
                });
                if (selectedCity !== true) {
                    cityOptions && cityOptions.forEach(select => {
                        if (select.options) {
                            select.options[0].display = "block";
                            select.options[0].selected = true;
                            document.querySelector('input[name=\'regionId\']').value = "";
                        }
                    });
                }
            },
            showOrdersDisabledPopup() {
                if ($("#orders-disabled-popup").length) {
                    $.fancybox({
                        href: "#orders-disabled-popup"
                    });
                }
            },
            submitOrderForm(val) {
                if (this.$refs.orderForm) {
                    this.$refs.orderForm.submitForm(val);
                }
            },
            ageConfirmationReject() {
                this.ageConfirmationRejected = true;
            },
            showShopSelect(options) {
                var options = options || {};
                this.$refs.shopSelectPopup.open(options);
            },
            deleteMainShop() {
                vxCommonStore.commit("deleteMainShop");
            },
            productAddedToCart() {
                if (typeof(this.$refs.basketline) != "undefined") {
                    this.$refs.basketline.update();
                }
            },
            getCatalogUploadDate(format) {
                return moment.unix(vxCommonStore.state.catalogUploadTimestamp).format(format);
            },
            toggleMetaViewPort(bool) {
                vxCommonStore.commit("setViewportDisabled", bool);
            },
            showPopup(selector) {
                $.fancybox({
                    href: selector,
                    helpers: {
                        title: {
                            type: "inside"
                        }
                    },
                    beforeShow() {
                        $("body").addClass("fancybox-active");
                    },
                    afterShow() {
                        if ($("body").hasClass("mobile")) {
                            window.scrollTo(0, 0);
                        }
                    },
                    afterClose() {
                        $("body").removeClass("fancybox-active");
                    }
                });
            },
            cookiesSet(name, val) {
                Cookies.set(name, val);
            },
            cookiesGet(name) {
                return Cookies.get(name);
            },
            cookiesGetJson(name) {
                return Cookies.getJSON(name);
            },
            addCounterBanner(id,tableId){

                let body = new FormData;
                body.append("ajax_command", "addCounterElement");
                body.append("id", id);
                body.append("tableId", tableId);
                body.append("z", "1");

                fetch("/local/php_interface/ajax/", {
                    method: "POST",
                    body
                })
                    .then(response => response.json())
                    .then(json => {


                    })
                    .catch(console.error)
                    .finally(() => {
                        e.target.disabled = false;
                    });

            },
        }
    });
}

/** Временные костыли */
$("body").on("click", ".pr_card_tabs_cont_inner--shops_list input[name='selected_shop[]']", function() {
    var id = +$(this).val();

    var shop = _.find(vxCommonStore.state.shopsData, shop => shop.id == id);

    vxCommonStore.commit("setMainShop", shop);

});

$("body.page_address").on("click", ".shop_list_wrapper input[name='selected_shop[]']", function() {
    var id = +$(this).val();

    var shop = _.find(vxCommonStore.state.shopsData, shop => shop.id == id);

    vxCommonStore.commit("setMainShop", shop);
});

require("./calc.js");


window.popupForm = e => {
    $.fancybox({
        href: "#messageSended",
        closeBtn: false,
        beforeShow() {
            $("body").addClass("fancybox-active");
        },
        afterClose() {
            $("body").removeClass("fancybox-active");
        }
    });
};

$("body").on("click", ".close-form", e => {
    $.fancybox.close();
});

$("body").on("click", ".order-item__header-arrow", function() {
    $(this).closest(".order-item").toggleClass("js__opened");
});




function checkAvailableMenuItem() {
    const menuItems = document.querySelectorAll('[data-exam="true"]')
    menuItems.forEach(async item => {
        const result = await fetch(`${item.getAttribute('href')}?ajax=Y&isProduct=true`, {
            method: 'GET',
        });
        const data = await result.json();
        if (data.isProduct === 'Y') {
            item.classList.add('active');
        }
    })

}
